// ====================================
// TransitionTimeline.jsx
// ====================================
import React from 'react';
import Button from '@/components/ui/Button';
import Icon from '@/components/AppIcon';

const TransitionTimeline = ({ plan, onUpdatePlan }) => {
const handlePhaseUpdate = (phaseId, status) => {
const updatedPhases = plan.phases.map(phase =>
phase.id === phaseId ? { ...phase, status } : phase
);
onUpdatePlan({ ...plan, phases: updatedPhases });
};

return (
<div className="bg-card border border-border rounded-lg p-6">
<h3 className="text-lg font-semibold text-text-primary mb-4">Transition Timeline</h3>

<div className="space-y-6">
{plan.phases?.map((phase, index) => (
<div key={phase.id} className="relative">
{index < plan.phases.length - 1 && (
<div className="absolute left-5 top-12 bottom-0 w-0.5 bg-border" />
)}

<div className="flex items-start space-x-4">
<div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
phase.status === 'completed' ? 'bg-success text-white' :
phase.status === 'in_progress' ? 'bg-primary text-white' :
'bg-muted text-text-secondary'
}`}>
{phase.status === 'completed' ? (
<Icon name="Check" size={16} />
) : (
<span>{index + 1}</span>
)}
</div>

<div className="flex-1">
<h4 className="text-base font-semibold text-text-primary">{phase.title}</h4>
<p className="text-sm text-text-secondary mb-2">{phase.duration}</p>

<ul className="space-y-1 mb-3">
{phase.activities?.map((activity, idx) => (
<li key={idx} className="text-sm text-text-primary flex items-center space-x-2">
<Icon name="Minus" size={12} className="text-text-secondary" />
<span>{activity}</span>
</li>
))}
</ul>

{phase.status === 'not_started' && (
<Button
size="sm"
variant="outline"
onClick={() => handlePhaseUpdate(phase.id, 'in_progress')}
>
Start Phase
</Button>
)}
{phase.status === 'in_progress' && (
<Button
size="sm"
onClick={() => handlePhaseUpdate(phase.id, 'completed')}
>
Mark Complete
</Button>
)}
</div>
</div>
</div>
))}
</div>
</div>
);
};

export default TransitionTimeline;